const validateNote = (note) => {
    return note;
}

export default validateNote;